import { Inbox } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function EmptyState({ title, description, primaryCta, secondaryCta, testid, level = 2, icon: Icon = Inbox }) {
  const Heading = `h${level}`;
  const action = (cta) => cta && (cta.to ? <Button asChild variant="outline"><Link to={cta.to} data-testid={cta.testid}>{cta.label}</Link></Button> : <Button type="button" variant="outline" onClick={cta.onClick} data-testid={cta.testid}>{cta.label}</Button>);
  return <div role="status" className="rounded-xl border border-dashed border-border p-6 sm:p-10 text-center space-y-3 break-words" data-testid={testid}>
    <Icon className="h-7 w-7 mx-auto text-muted-foreground" aria-hidden="true" />
    <Heading className="font-display font-semibold text-lg">{title}</Heading>
    {description && <p className="text-sm text-muted-foreground">{description}</p>}
    {(primaryCta || secondaryCta) && <div className="flex flex-wrap justify-center gap-2"><span data-testid={primaryCta?.containerTestid}>{action(primaryCta)}</span>{action(secondaryCta)}</div>}
  </div>;
}
